import { Box } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import CustomDataGridV2 from "../../../../../components/CustomDataGridV2";
import Text from "../../../../../components/Text";
import ActionMenu from "../../../../../components/app/ActionMenu";
import DeleteModal from "../../../../../components/app/DeleteModal";
import { useReduceDisclosure } from "../../../../../hooks/use-reduce-disclosure";
import { useFlagArchive } from "../../../../../queries/flags/flags/use-flag-archive";
import { useGetFlagList } from "../../../../../queries/flags/flags/use-get-flag-list";
import { NonNullableDate } from "../../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
  getXtenantId,
} from "../../../../../utils/utils";
import UpsertFlag from "./UpsertFlag";
import { useOutletContext } from "react-router-dom";
const FlagList = () => {
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [gridSorting, setGridSorting] = useState<GridSortItem[]>([]);
  const { flagSearch } = useOutletContext<{
    flagSearch: string;
    setFlagSearch: (value: string) => void;
  }>();

  const {
    data: flagList,
    isLoading: tableDataLoading,
    refetch,
  } = useGetFlagList({
    gridSorting,
    pagination,
    name: flagSearch,
    xTENANTID: getXtenantId(),
    active: true,
    archive: false,
  });
  const { mutateAsync: archiveFlag } = useFlagArchive();
  const [upsertFlagDisclosure, deleteDis] = useReduceDisclosure(2);

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "name",
      flex: 0.6,
      minWidth: 150,
      headerName: "Flag",
    },
    {
      field: "color",
      flex: 0.4,
      minWidth: 120,
      headerName: "Color",
      renderCell: ({ row }) => (
        <Box
          sx={{
            width: "41px",
            height: "20px",
            backgroundColor: row.color,
            borderRadius: "4px",
            display: "inline-block",
          }}
        />
      ),
    },
    {
      field: "createdAt",
      flex: 0.5,
      minWidth: 160,
      disableColumnMenu: true,
      headerName: "Created Date",
      renderCell: ({ value }) => (
        <Text isTabletext>{NonNullableDate(value)}</Text>
      ),
    },
    {
      field: "Action",
      width: 90,
      // todo need to fix type
      renderCell: ({ row }) => {
        return (
          <ActionMenu
            options={[
              { value: "edit", label: "Edit" },
              { value: "delete", label: "Delete" },
            ]}
            onActionClick={(v) => {
              if (v === "edit") {
                upsertFlagDisclosure.open(row);
              } else {
                deleteDis.open(row.uuid);
              }
            }}
          />
        );
      },
    },
  ]);

  return (
    <>
      <UpsertFlag disclosureHost={upsertFlagDisclosure} />
      <DeleteModal
        w="380px"
        open={deleteDis.opened}
        onClose={deleteDis.close}
        id={deleteDis?.data}
        onConfirmation={(id) =>
          archiveFlag({
            id: id,
            status: true,
            xTENANTID: getXtenantId(),
          }).then((res) => {
            refetch();
            return res;
          })
        }
        content={"You want to delete Flag ?"}
      />
      <Box flex={1} minHeight={0}>
        <CustomDataGridV2
          loading={tableDataLoading}
          rows={flagList?.data?.content ?? []}
          getRowId={(row) => row?.uuid}
          columns={COLUMNS}
          onPaginationModelChange={setPagination}
          onSortModelChange={setGridSorting}
          paginationModel={pagination}
          keepNonExistentRowsSelected
          rowCount={flagList?.data.page.totalElements}
          rowHeight={56}
        />
      </Box>
    </>
  );
};

export default FlagList;
